module.exports = __webpack_public_path__ + "img/pota-logos.d3bf2069.png";